<template>
  <section class="container">
    <div class="card">
      <div class="card-body">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="fixedNavbar" v-model="fixedNavbar">
          <label class="custom-control-label" for="fixedNavbar">Menu dan bar atas selalu kelihatan</label>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  middleware: 'auth',
  data() {
    return {
      fixedNavbar: this.$store.state.fixedNavbar
    }
  },

  // computed: {
  //   fixedNavbar() {
  //     return this.$store.state.fixedNavbar
  //   }
  // },

  watch: {
    fixedNavbar(isChecked) {
      this.$store.commit('toggleFixedNavbar')
    }
  }
}  
</script>